import { Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Placeholder used by industry-specific nav items whose dedicated dashboard
 * page hasn't been built yet (Waitlist, Patients, Estimates, Matters, Listings).
 * Keeps the sidebar link working without dead-ending the user.
 */
export default function ComingSoonPage({ feature = 'This feature', industry = 'your industry' }) {
  return (
    <div data-testid={`coming-soon-${feature.toLowerCase().replace(/\s+/g, '-')}`} className="max-w-xl mx-auto py-16">
      <div className="bg-white dark:bg-white/[0.04] dark:backdrop-blur-xl border border-gray-200 dark:border-white/10 rounded-2xl p-8 text-center">
        <div className="w-12 h-12 mx-auto bg-blue-50 dark:bg-blue-500/15 rounded-full flex items-center justify-center mb-4">
          <Sparkles className="w-5 h-5 text-blue-600 dark:text-blue-400" />
        </div>
        <h1 className="font-heading text-2xl font-semibold text-gray-900 dark:text-white mb-2">
          {feature}, coming soon
        </h1>
        <p className="text-gray-500 dark:text-slate-400 text-sm mb-6">
          We're building a dedicated {feature} workspace for {industry}. In the meantime, Ava is already capturing every relevant lead, call and appointment for you in the existing tabs.
        </p>
        <Link
          to="/dashboard"
          data-testid="coming-soon-back-btn"
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 dark:hover:bg-blue-400 text-white text-sm font-medium rounded-full px-5 py-2.5">
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
